import { useTheme } from "@mui/material";
import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

interface MarkProps extends SvgIconProps {
  markColor?: string;
}

export const Mark: React.FC<MarkProps> = ({ markColor, ...props }) => {
  const theme = useTheme();
  return (
    <SvgIcon {...props} viewBox="0 0 18 2" fill="none">
      <path
        d="M1 1H17"
        stroke={markColor || theme.palette.ROILineChart.lineColor}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </SvgIcon>
  );
};

export default Mark;
